import logoImage from "../logos/the-batters-box-icon.svg"

function BatterIconLogo({logoID}) {
    return (
        <img id={logoID} src={logoImage} alt="Logo"></img>
    )
}

export default BatterIconLogo